export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    SHOP: '/shop',
    OTP: '/login/otp',
    PLAYER_ID: '/login/playerId',
    USERNAME: '/login/username',
    FAILED_LOGIN: '/failed',
    OTP_DEEP_LINK: '/store/otp/deeplink/v2',
    OTP_DESKTOP: '/login/otp-desktop',
    SUPPORT: '/support',
    CLEAR_SESSION: '/api/auth/clear-session',
} as const;